module.exports = __webpack_public_path__ + "static/media/est_0005_f.2a291d27.jpg";